import {
    bexHttpClient
} from '../../clients';
import {
    CreateChannelRequest,
    UpdateChannelRequest,
    DeleteChannelRequest,
    CreateChannelResponse,
    UpdateChannelResponse,
    DeleteChannelResponse,
    GetChannelResponse,
    ListChannelsResponse
} from '../bexService.types';

/**
 * Service class for performing channel operations.
 */
class ChannelService {

    /**
     * Fetches the sub organization channels.
     * @returns {Promise<ListChannelsResponse>} The response from the server returns sub organization channels.
     */
    async getChannels(organizationId: string, subOrganizationId: string, page?: number, limit?: number): Promise<ListChannelsResponse> {
        let url = `/redis/channels/list-channels?org_id=${organizationId}&sub_org_id=${subOrganizationId}`;
        if (page !== undefined) url += `&page=${page}`;
        if (limit !== undefined) url += `&limit=${limit}`;
        const response = await bexHttpClient.get(url);
        return response;
    }

    /**
     * Fetches the sub organization channels.
     * @returns {Promise<GetChannelResponse>} The response from the server returns sub organization channels.
     */
    async getChannelById(organizationId: string, subOrganizationId: string, channelId: string): Promise<GetChannelResponse> {
        const response = await bexHttpClient.get(`/redis/channels/get-channel?org_id=${organizationId}&sub_org_id=${subOrganizationId}&channelId=${channelId}`);
        return response;
    }

    /**
     * get temp email auth
     * @returns {Promise<any>} The response from the server returns temp email auth
     */
    async getTempEmail(organizationId: string, subOrganizationId: string, email: string): Promise<any> {
        const response = await bexHttpClient.get(`/db/hotel-auth/get-email-auth-temp?organization_id=${organizationId}&sub_organization_id=${subOrganizationId}&email_auth=${email}`);
        return response;
    }

    /**
     * add new channel
     * @param {CreateChannelRequest} data - The new channel object includes organizationId, subOrganizationId, topic, address and any extra info
     * @returns {Promise<CreateChannelResponse>} The response from the server returns new channel document from mongoDB.
     */
    async addChannel(data: CreateChannelRequest): Promise<CreateChannelResponse> {
        const response = await bexHttpClient.post('/redis/channels/add-channel', data);
        return response;
    }

    /**
     * add new Baileys channel bypassing stripe
     * @param {CreateChannelRequest} data
     * @returns {Promise<CreateChannelResponse>}
     */
    async addBaileysChannel(data: CreateChannelRequest): Promise<CreateChannelResponse> {
        const response = await bexHttpClient.post('/redis/channels/add-baileys-channel', data);
        return response;
    }

    /**
     * update channel
     * @param {UpdateChannelRequest} data - The updated channel object includes organizationId, subOrganizationId, topic, address and any extra info
     * @returns {Promise<UpdateChannelResponse>} The response from the server returns updated channel document from mongoDB.
     */
    async updateChannel(data: UpdateChannelRequest): Promise<UpdateChannelResponse> {
        const response = await bexHttpClient.put('/redis/channels/update-channel', data);
        return response;
    }

    /**
     * delete channel
     * @param {DeleteChannelRequest} data - The deleted channel object includes organizationId, subOrganizationId and channelId
     * @returns {Promise<DeleteChannelResponse>} The response from the server returns deletion status.
     */
    async deleteChannel(data: DeleteChannelRequest): Promise<DeleteChannelResponse> {
        const response = await bexHttpClient.delete('/redis/channels/delete-channel', {
            data
        });
        return response;
    }

}

const channelService = new ChannelService();
export { channelService };